import React from 'react';
import { useTranslation } from 'react-i18next';

const GearIcon = () => (
  <svg
    width="48"
    height="49"
    viewBox="0 0 48 49"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_37_187)">
      <path
        d="M25.9999 26.08C24.8799 27.2 23.0999 27.2 21.9999 26.1V26.08C20.8999 24.98 20.8999 23.2 21.9999 22.1V22.08C23.0999 20.98 24.8799 20.98 25.9799 22.08H25.9999C27.0999 23.18 27.0999 24.98 25.9999 26.08ZM23.9999 12.08L28.2399 16.32L33.2399 11.32L26.8399 4.92C25.2799 3.36 22.7399 3.36 21.1799 4.92L14.7799 11.32L19.7799 16.32L23.9999 12.08ZM11.9999 24.08L16.2399 19.84L11.2399 14.84L4.83992 21.24C3.27992 22.8 3.27992 25.34 4.83992 26.9L11.2399 33.3L16.2399 28.3L11.9999 24.08ZM35.9999 24.08L31.7599 28.32L36.7599 33.32L43.1599 26.92C44.7199 25.36 44.7199 22.82 43.1599 21.26L36.7599 14.86L31.7599 19.86L35.9999 24.08ZM23.9999 36.08L19.7599 31.84L14.7599 36.84L21.1599 43.24C22.7199 44.8 25.2599 44.8 26.8199 43.24L33.2199 36.84L28.2199 31.84L23.9999 36.08Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_37_187">
        <rect
          width="48"
          height="48"
          fill="white"
          transform="translate(0 0.0800781)"
        />
      </clipPath>
    </defs>
  </svg>
);

const RecycleIcon = () => (
  <svg
    width="48"
    height="49"
    viewBox="0 0 48 49"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_37_199)">
      <path
        d="M32 20.0801H16C14.9 20.0801 14 20.9801 14 22.0801C14 23.1801 14.9 24.0801 16 24.0801H32C33.1 24.0801 34 23.1801 34 22.0801C34 20.9801 33.1 20.0801 32 20.0801ZM38 6.08008H36V4.08008C36 2.98008 35.1 2.08008 34 2.08008C32.9 2.08008 32 2.98008 32 4.08008V6.08008H16V4.08008C16 2.98008 15.1 2.08008 14 2.08008C12.9 2.08008 12 2.98008 12 4.08008V6.08008H10C7.78 6.08008 6 7.88008 6 10.0801V38.0801C6 40.2801 7.78 42.0801 10 42.0801H38C40.2 42.0801 42 40.2801 42 38.0801V10.0801C42 7.88008 40.2 6.08008 38 6.08008ZM36 38.0801H12C10.9 38.0801 10 37.1801 10 36.0801V16.0801H38V36.0801C38 37.1801 37.1 38.0801 36 38.0801ZM26 28.0801H16C14.9 28.0801 14 28.9801 14 30.0801C14 31.1801 14.9 32.0801 16 32.0801H26C27.1 32.0801 28 31.1801 28 30.0801C28 28.9801 27.1 28.0801 26 28.0801Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_37_199">
        <rect
          width="48"
          height="48"
          fill="white"
          transform="translate(0 0.0800781)"
        />
      </clipPath>
    </defs>
  </svg>
);

const EuropeanMadeQuality = () => (
  <svg
    width="48"
    height="49"
    viewBox="0 0 48 49"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_37_176)">
      <path
        d="M42 20.0801C39.8 20.0801 38 21.8801 38 24.0801V30.0801H10V24.0801C10 21.8801 8.2 20.0801 6 20.0801C3.8 20.0801 2 21.8801 2 24.0801V34.0801C2 36.2801 3.8 38.0801 6 38.0801H42C44.2 38.0801 46 36.2801 46 34.0801V24.0801C46 21.8801 44.2 20.0801 42 20.0801ZM36 10.0801H12C9.8 10.0801 8 11.8801 8 14.0801V18.3801C10.32 19.2001 12 21.4001 12 24.0201V28.0801H36V24.0201C36 21.4201 37.68 19.2201 40 18.3801V14.0801C40 11.8801 38.2 10.0801 36 10.0801Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_37_176">
        <rect
          width="48"
          height="48"
          fill="white"
          transform="translate(0 0.0800781)"
        />
      </clipPath>
    </defs>
  </svg>
);

const Dealerships = () => (
  <svg
    width="48"
    height="49"
    viewBox="0 0 48 49"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_37_210)">
      <path
        d="M42 24.5201C42 13.5401 33.48 6.08008 24 6.08008C14.62 6.08008 6 13.3801 6 24.6401C4.8 25.3201 4 26.6001 4 28.0801V32.0801C4 34.2801 5.8 36.0801 8 36.0801C9.1 36.0801 10 35.1801 10 34.0801V24.4601C10 16.8001 15.9 10.1001 23.56 9.88008C31.48 9.64008 38 16.0001 38 23.8801V38.0801H24C22.9 38.0801 22 38.9801 22 40.0801C22 41.1801 22.9 42.0801 24 42.0801H38C40.2 42.0801 42 40.2801 42 38.0801V35.6401C43.18 35.0201 44 33.8001 44 32.3601V27.7601C44 26.3601 43.18 25.1401 42 24.5201Z"
        fill="currentColor"
      />
      <path
        d="M18 28.0801C19.1046 28.0801 20 27.1846 20 26.0801C20 24.9755 19.1046 24.0801 18 24.0801C16.8954 24.0801 16 24.9755 16 26.0801C16 27.1846 16.8954 28.0801 18 28.0801Z"
        fill="currentColor"
      />
      <path
        d="M30 28.0801C31.1046 28.0801 32 27.1846 32 26.0801C32 24.9755 31.1046 24.0801 30 24.0801C28.8954 24.0801 28 24.9755 28 26.0801C28 27.1846 28.8954 28.0801 30 28.0801Z"
        fill="currentColor"
      />
      <path
        d="M35.9999 22.1401C35.0399 16.4401 30.0799 12.0801 24.0999 12.0801C18.0399 12.0801 11.5199 17.1001 12.0399 24.9801C16.9799 22.9601 20.6999 18.5601 21.7599 13.2001C24.3799 18.4601 29.7599 22.0801 35.9999 22.1401Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_37_210">
        <rect
          width="48"
          height="48"
          fill="white"
          transform="translate(0 0.0800781)"
        />
      </clipPath>
    </defs>
  </svg>
);

const featureIcons = [
  <EuropeanMadeQuality />,
  <GearIcon />,
  <RecycleIcon />,
  <Dealerships />,
  <Dealerships />,
  <Dealerships />,
];

const Card = ({ title, icon, highlighted, description }) => (
  <div
    className={`group w-full sm:max-w-[293px] rounded-[16px] flex flex-col justify-between p-6 bg-white transition-all duration-300 ${
      highlighted ? '' : ''
    } hover:shadow-[4px_4px_48px_0px_#1E25370F]`}
  >
    <div className="flex flex-col items-start">
      <div className="text-[#8F8F8F] group-hover:text-black transition-colors duration-300">
        {icon}
      </div>

      <h4 className="libre-baskerville text-[28px] font-normal tracking-[-0.84px] leading-[40px] text-[#15202E] mt-8 mb-4">
        {title}
      </h4>
      <p className="text-[#525252] font-normal text-[16px] leading-[25px]">
        {description}
      </p>
    </div>
    <button className="mt-6 group-hover:text-[#00001D] text-[#8F8F8F]">
      <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_37_182)">
          <path
            d="M14.29 5.79055C13.9 6.18055 13.9 6.81055 14.29 7.20055L18.17 11.0805H3C2.45 11.0805 2 11.5305 2 12.0805C2 12.6305 2.45 13.0805 3 13.0805H18.18L14.3 16.9605C13.91 17.3505 13.91 17.9805 14.3 18.3705C14.69 18.7605 15.32 18.7605 15.71 18.3705L21.3 12.7805C21.69 12.3905 21.69 11.7605 21.3 11.3705L15.7 5.79055C15.32 5.40055 14.68 5.40055 14.29 5.79055Z"
            fill="currentColor"
          />
        </g>
        <defs>
          <clipPath id="clip0_37_182">
            <rect
              width="24"
              height="24"
              fill="white"
              transform="translate(0 0.0800781)"
            />
          </clipPath>
        </defs>
      </svg>
    </button>
  </div>
);

const WhyChooseUs = () => {
  const { t } = useTranslation();
  const featureTitles = t('home.why.features', { returnObjects: true }) || [];
  const features = featureTitles.map((title, idx) => ({
    title,
    icon: featureIcons[idx],
  }));
  return (
    <section className="px-4 sm:px-6 xl:px-8 py-[60px] md:py-[120px]">
      <div className="w-full max-w-[1244px] mx-auto">
        <h2 className="text-center libre-baskerville text-[35px] sm:text-[67px] font-normal leading-[45px] sm:leading-[83px] text-[#15202E] tracking-[-2.01px]">
          {t('home.why.title')}
        </h2>
        <div className="mt-8 sm:mt-[45px] hidden lg:flex flex-col items-center gap-6">
          <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-6 items-center place-items-center justify-items-center w-full">
            {features.slice(0, 4).map((f, idx) => (
              <Card
                key={idx}
                {...f}
                highlighted={idx === 0}
                description={t('home.why.cardDescription')}
              />
            ))}
          </div>

          <div className="flex flex-col sm:flex-row gap-6 justify-center items-center">
            {features.slice(4).map((f, idx) => (
              <Card
                key={idx + 4}
                {...f}
                description={t('home.why.cardDescription')}
              />
            ))}
          </div>
        </div>
        <div className="mt-10 sm:mt-[45px] lg:hidden grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 sm:gap-6 items-center place-items-center justify-items-center">
          {features.map((f, idx) => (
            <Card
              key={idx}
              {...f}
              highlighted={idx === 0}
              description={t('home.why.cardDescription')}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
